import PeopleSettings from './PeopleSettings';

export default PeopleSettings;
